import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateChatSettings as UpdateChatSettingsMutation,
    UpdateChatSettingsVariables as UpdateChatSettingsMutationVariables,
    ChatSettingsUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_CHAT_SETTINGS from '../mutations/update-chat-settings.graphql';

export const useUpdateChatSettings = (): {
    updateChatSettings: (input: ChatSettingsUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateChatSettings, {loading, error}] = useMutation<
        UpdateChatSettingsMutation,
        UpdateChatSettingsMutationVariables
    >(UPDATE_CHAT_SETTINGS);

    return {
        updateChatSettings: (input: ChatSettingsUpdateInput) => {
            return updateChatSettings({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
